module.exports = __webpack_public_path__ + "static/media/contact-us-amico-business.0fec42f7.svg";